/**
 * SnapFig GA4 Tracking Initialization
 * Initializes event listeners for tracking user interactions
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  function init() {
    if (typeof GtagUtils === 'undefined') {
      console.warn('[GtagTracking] GtagUtils not available, retrying...');
      setTimeout(init, 100);
      return;
    }

    console.log('[GtagTracking] Initializing SnapFig GA tracking...');
    // Custom event tracking is initialized via GtagUtils methods called directly from components
  }

  /**
   * Get tracking data from session storage
   */
  function getTrackingDataFromStorage() {
    try {
      var data = sessionStorage.getItem('snapfig_tracking_data');
      return data ? JSON.parse(data) : {};
    } catch (e) {
      return {};
    }
  }

  /**
   * Save tracking data to session storage (call this during the flow)
   */
  function saveTrackingData(data) {
    try {
      var existing = getTrackingDataFromStorage();
      var merged = Object.assign({}, existing, data);
      sessionStorage.setItem('snapfig_tracking_data', JSON.stringify(merged));
    } catch (e) {
      // Ignore storage errors
    }
  }

  /**
   * Increment upload count in tracking data
   */
  function incrementUploadCount() {
    var data = getTrackingDataFromStorage();
    data.uploadsBeforeOrder = (data.uploadsBeforeOrder || 0) + 1;
    saveTrackingData(data);
  }

  /**
   * Increment generation count in tracking data
   */
  function incrementGenerationCount(imageCount, modelName) {
    var data = getTrackingDataFromStorage();
    data.generationsBeforeOrder = (data.generationsBeforeOrder || 0) + 1;
    data.imagesGeneratedBeforeOrder = (data.imagesGeneratedBeforeOrder || 0) + (imageCount || 0);
    if (modelName) {
      data.modelName = modelName;
    }
    saveTrackingData(data);
  }

  // Expose helper functions for other scripts to use
  window.GtagTrackingHelpers = {
    saveTrackingData: saveTrackingData,
    incrementUploadCount: incrementUploadCount,
    incrementGenerationCount: incrementGenerationCount,
    getTrackingDataFromStorage: getTrackingDataFromStorage
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
